import { useEffect } from "react";
import { type Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";

export default function AllTasksRedirectPage() {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    navigate(`/tasks/my-tasks${search}` as Path, { replace: true });
  }, [navigate, search]);

  return null;
}
